import $ from 'jquery';
let didScroll = false;
let lastScrollTop = 0;
let menuIsOpen = false;

$('.site-header-component .menu-button').on('click', function () {
  $(this).toggleClass('active');
  if ($('.site-header-component .full-menu').hasClass('active')) {
    $('.site-header-component .header-bar').removeClass('active');
    $('.site-header-component .header-bar .logo').addClass('active');
    $('.site-header-component .header-bar .logo-white').removeClass('active');
    $('.site-header-component .full-menu').removeClass('active');
    menuIsOpen = false;
  } else {
    $('.site-header-component .header-bar').addClass('active');
    $('.site-header-component .header-bar .logo').removeClass('active');
    $('.site-header-component .header-bar .logo-white').addClass('active');
    $('.site-header-component .full-menu').addClass('active');
    menuIsOpen = true;
  }
});

$(window).on('scroll', function(event) {
  didScroll = true;
});

setInterval(function() {
  if (didScroll) {
    hasScrolled();
    didScroll = false;
  }
}, 250);

function hasScrolled() {
  let scrollTolerance = 5;
  let thisScrollTop = $(window).scrollTop();
  let scrollDelta = Math.abs(lastScrollTop - thisScrollTop);
  if (scrollDelta < scrollTolerance) {
    return;
  }
  let header = $('#site-header');
  if (lastScrollTop - thisScrollTop > 0) {
    header.addClass('sticky');
  } else {
    header.removeClass('sticky');
  }
  if (thisScrollTop < scrollTolerance) {
    header.removeClass('sticky');
  }
  lastScrollTop = thisScrollTop;
}